import "./style.sass";
import assets from "../../assets";

export const DescriptiveHero = () => {
  return (
    <section className="descriptive-container">
      <section className="icon-circle">
        <img src={assets.ic_desc_test} alt="desc test" />
      </section>

      <h1 className="title">Descriptive Test</h1>
      <p className="subtitle">
        AI-powered question generation and intelligent evaluation system
      </p>

      <section className="info-card">
        <h3>Why use AI descriptive generator?</h3>

        <div className="features-grid">
          <section className="feature">
            <section className="feature-icon">📝</section>
            <section>
              <h4>Custom Topics</h4>
              <p>Generate precise questions on any subject.</p>
            </section>
          </section>

          <section className="feature">
            <section className="feature-icon">🧠</section>
            <section>
              <h4>Concept Analysis</h4>
              <p>Deep dive into complex theoretical concepts.</p>
            </section>
          </section>

          <section className="feature">
            <section className="feature-icon">🚀</section>
            <section>
              <h4>Skill Mastery</h4>
              <p>Perfect your answer writing and structural skills.</p>
            </section>
          </section>
        </div>
      </section>

      <section className="instruction-box">
        Get started by selecting your subject, chapter, language,
        Number of Questions and Question Weightage
      </section>
    </section>
  );
};
